
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Initialize dataLayer for Google Tag Manager
window.dataLayer = window.dataLayer || [];
function gtag(...args: any[]) {
  window.dataLayer.push(args);
}
window.gtag = gtag;

// Use requestIdleCallback to initialize non-critical operations
const initialize = () => {
  // Initialize the app
  const rootElement = document.getElementById("root");
  if (rootElement) {
    createRoot(rootElement).render(<App />);
  }
};

// Use requestIdleCallback for non-critical initialization when browser is idle
// Fall back to setTimeout if requestIdleCallback isn't available
if ('requestIdleCallback' in window) {
  window.requestIdleCallback(initialize);
} else {
  // Fallback for browsers that don't support requestIdleCallback
  setTimeout(initialize, 1);
}
